// ── IMAGE SLOTS (Special Ed Ready) ────────────────────────────
// Hosted in the Impultienda store resources (Recursos).
const STORE = '1294545c-4bab-4af5-8083-9139707997a8';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code (no AI text): the Gamma Studio cover plus
 * real pages 4 and 9 on the iMac, and the Impultienda bonus photos with their titles typed in. Pure white background.
 */
const IMAC = RES + '1792681590613_ser-mockup-imac-ac91447f.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Real pages of the Gamma Studio book (9:16), same order as lookInside.captions: p.4 (fixed), 17, 18 (fixed), 19, 36, 39. */
export const pageImages: string[] = [
  RES + '1792681614668_ser-pagina-04-plan-q1-aa3d0ebd.webp',
  RES + '1792681641285_ser-pagina-17-week04-plan-333d1690.webp',
  RES + '1792681646297_ser-pagina-18-week04-read-2b508084.webp',
  RES + '1792681650969_ser-pagina-19-week04-do-eddfa242.webp',
  RES + '1792681655684_ser-pagina-36-week10-read-35e79a0c.webp',
  RES + '1792681660353_ser-pagina-39-planner-3bc903bb.webp',
];
/** 5 bonus covers (titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  RES + '1792681594995_ser-bono-1-rutinas-c52abb58.webp',
  RES + '1792681598708_ser-bono-2-historias-5ee0a35c.webp',
  RES + '1792681602462_ser-bono-3-familias-759c9e7c.webp',
  RES + '1792681606227_ser-bono-4-para-703c3497.webp',
  RES + '1792681610293_ser-bono-5-iep-b4c9c8ca.webp',
];
